import React, {FC, useEffect, useRef, useState} from 'react';
import {
    IFailureMode,
    IProjectFailureMode
} from "../types/types";
import {get, post} from "../fetchers/fetchers";

 
import {
    Button, Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton, Table, TableBody, TableCell, TableHead, TableRow,
    TextField,
    TextFieldProps
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DialogContentText from "@material-ui/core/DialogContentText";
import {CheckBox, Edit} from "@material-ui/icons";
import { API_URL } from "../env";

interface IProjectFailureModesProps {
    updateSelectedFailureModes: (failureModes: IFailureMode[]) => void;
    assessment_id?: number

}



const ProjectFailureModes: FC<IProjectFailureModesProps> = ({
                                                                updateSelectedFailureModes,
                                                                assessment_id
                                                            }) => {


    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const newFailureMode = useRef<TextFieldProps>(null);

    const [failureModes, setFailureModes] = useState<IFailureMode[]>([])
    const [assessmentFailureModes, setAssessmentFailureModes] = useState<IProjectFailureMode[]>([])

    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [currentFailureMode, setCurrentFailureMode] = useState<IFailureMode>();


    const getFailureModes = async (set_mode: boolean):Promise<IFailureMode[]> => {
        const d = await get<IFailureMode[]>( API_URL + "failure_modes/")
        if (set_mode) {
            setFailureModes(d)
        }
        return d
    }

    const getFailureAssessmentModes = async ():Promise<IProjectFailureMode[]> => {
        const d = await get<IProjectFailureMode[]>( API_URL + "failure_modes/" + assessment_id)
        return d
    }

    const updateFailureModes = (fmodes:IFailureMode[], pmodes:IProjectFailureMode[]) => {

        let f_modes = [...fmodes]

        pmodes.map((pm) => {
            let f = f_modes.find( (f) => f.uuid === pm.failure_mode_id)
            if (f) {
                f.selected = true
                f.existing = true
            }
        })

        setFailureModes(f_modes)

    }

    useEffect(() => {
            if (!assessment_id) {
                if (!isLoaded && !isLoading) {
                    setIsLoading(true)
                    getFailureModes(true).then(
                        () => {
                            setIsLoaded(true)
                            setIsLoading(false)
                        })
                }
            } else {
                if (!isLoaded && !isLoading) {
                    setIsLoading(true)
                    getFailureModes(false).then(
                        (fmodes) => {
                            getFailureAssessmentModes().then(
                                (pmodes) => {
                                    setIsLoaded(true)
                                    setIsLoading(false)
                                    updateFailureModes(fmodes, pmodes)
                                })
                        })
                }
            }
        }
        , [isLoaded, isLoading, assessment_id, getFailureModes])

    const setSelected = (index: number, f: IFailureMode) => {
        let fms = [...failureModes];
        let fm = {...f}
        fm.selected = !f.selected
        fms[index] = {...fm}
        updateSelectedFailureModes(fms)
        setFailureModes(fms)

    }


    const handleClose = () => {
        setOpenCreateDialog(false)
    }
    const handleOpen = () => {
        setOpenCreateDialog(true)
    }


    const addFailureMode = async (f: IFailureMode) => {
        let fm  = {...f}
        delete fm.id;
        delete fm.selected;
        delete fm.existing;

        await post<IFailureMode>( API_URL + "failure_modes/", fm);
        setIsLoaded(false)
    }

    const handleAddFailureMode = () => {
        if(!currentFailureMode) {
            throw new Error("Current Failure Mode needs to be set")
        }

        addFailureMode(currentFailureMode).then(() => setOpenCreateDialog(false))
    }

    const handleEdit = (fm :IFailureMode) => {
        setCurrentFailureMode(fm);
        setOpenCreateDialog(true);
    }

    const renderFailureMode = (index: number, f: IFailureMode) => {
        return (
            <TableRow>
                <TableCell>
                    <Checkbox
                        checked={f.selected}
                        disabled={f.existing}
                        color="primary"
                        onChange={() => {
                            setSelected(index, f)
                        }}
                    />
                </TableCell>
                <TableCell>{f.name}</TableCell>
                <TableCell>
                    <Checkbox
                        checked={f.is_active}
                        disabled={true}
                        color="primary"
                    />
                </TableCell>
                <TableCell>               <IconButton color="primary" aria-label="upload picture" component="span" style={{
                    color:"rgb(239,88,43)",

                }} onClick={() => handleEdit(f)}>
                    <Edit />
                </IconButton></TableCell>
            </TableRow>
        )
    }

    return (
        <>
            <Dialog open={openCreateDialog} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth>
                <DialogTitle id="form-dialog-title">Failure Mode</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Add or Edit your Failure Mode
                    </DialogContentText>

                    <TextField
                        fullWidth
                        label="Failure Mode"
                        value={currentFailureMode?.name}
                        onChange={(event) => {
                            let v = (event.target.value as string);

                            let c = {...currentFailureMode} as IFailureMode
                            c.name = v


                            setCurrentFailureMode(c)
                        }} />
                    Visible
                    <Checkbox
                        
                        checked={currentFailureMode?.is_active}
                        color="primary"
                        onChange={() => {
                            let c = {...currentFailureMode} as IFailureMode
                            c.is_active = !c.is_active
                            setCurrentFailureMode(c)
                        }}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAddFailureMode} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>


            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Selected</TableCell>
                        <TableCell>Failure Mode</TableCell>
                        <TableCell>Visible</TableCell>
                        <TableCell>Control</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {failureModes.map((f, index) => {
                        return renderFailureMode(index, f)
                    })}

                </TableBody>
            </Table>
            <IconButton color="primary" component="span"
                        style={{
                            margin: "auto",
                            backgroundColor: "rgb(84,107,213)",
                            color: "rgb(255,255,255)"
                        }} onClick={() => {
                setCurrentFailureMode({uuid: -1, name: ""})
                handleOpen()
            }
                        }>
                <AddIcon fontSize="small"/>
            </IconButton>

        </>
    );
};

export default ProjectFailureModes;

